module.exports = __webpack_public_path__ + "assets/RetinaNarr-ExLightItalic.42e5f4b18741fdd67809d34dc05324b6.woff";